import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const serviceBaseEndpoint = ENDPOINTS.SERVICETYPE;

// Service Type API
export const serviceTypeApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["serviceTypes"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getServiceType: builder.query({
        query: (payload) => `${serviceBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "serviceTypes" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),

      addServiceType: builder.mutation({
        query: (requestData) => ({
          url: `${serviceBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "serviceTypes" }],
      }),
      updateServiceType: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${serviceBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "serviceTypes" }],
      }),
      deleteServiceType: builder.mutation({
        query: (id) => ({
          url: `${serviceBaseEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "serviceTypes" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetServiceTypeQuery,
  useAddServiceTypeMutation,
  useUpdateServiceTypeMutation,
  useDeleteServiceTypeMutation,
} = serviceTypeApi;
